// import './Signin.css'
import React, { useState, useEffect } from 'react';
import axios from 'axios'
import validator from 'validator';
import { SERVER_URL } from '../config'
import './Signin.css'
// import CenteredLogo from '../components/CenteredLogo';

const Signin = ({ setUserLoggedIn, setUser, setToken }) => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [passwordConf, setPasswordConf] = useState('')
    const [userName, setUserName] = useState('')
    const [registerPasswordsOK, setRegisterPasswordsOK] = useState(false)

    const [emailLogin, setEmailLogin] = useState('')
    const [passwordLogin, setPasswordLogin] = useState('')
    const [loginDetailsOk, setLoginDetailsOk] = useState(false)


    // const navigate = useNavigate()

    useEffect(() => {
        if (password === passwordConf && password.length > 7 && password.match(/[0-9]/) && password.match(/[!@#$%^&*]/) && validator.isEmail(email)) {
            setRegisterPasswordsOK(true)
        } else {
            setRegisterPasswordsOK(false)
        }
    }, [password, passwordConf, email])

    useEffect(() => {
        if (validator.isEmail(emailLogin) && passwordLogin.length > 7) {
            setLoginDetailsOk(true)
        } else {
            setLoginDetailsOk(false)
        }
    }
        , [emailLogin, passwordLogin])

    const loginfAuth = async (email, password) => {
        try {
            const response = await axios.post(`${SERVER_URL}/users/login`, { emailLogin: email, passwordLogin: password })
            if (response.data.ok) {
                //debugger
                // let decodedToken = jose.decodeJwt(response.data.token);
                setUser({ email: response.data.emailLogin })
                localStorage.setItem("token", JSON.stringify(response.data.token))
                setToken(response.data.token)
                setUserLoggedIn(true)
                // login(response.data.token);
                // setTimeout(() => {
                //     navigate("/");
                // }, 2000);
            } else {
                alert('Invalid login details')
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleLogin = async (e) => {
        e.preventDefault()
        loginfAuth(emailLogin, passwordLogin)
    }

    const handleRegister = async (e) => {
        e.preventDefault()
        try {

            const response = await axios.post(`${SERVER_URL}/users/register`, {
                userEmail: email, userPassword: password, userSignupDate: new Date(), userName
            });
            if (response.data.ok) {
                loginfAuth(email, password)
            } else if (response.data.message === 'User exists!') {
                alert('This user already exists, please try to login instead.')
                setPassword('')
                setPasswordConf('')
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <section className="signin">
            <article>

                <div className='bubbleContainer'>
                <h1>Sign up</h1>
                    <form onSubmit={handleRegister}>
                    <input type="text" placeholder="Your name or nickname" value={userName} onChange={(e) => setUserName(e.target.value)} />
                        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value.toLowerCase())} />
                        <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                        <input type="password" placeholder="Confirm password" value={passwordConf} onChange={(e) => setPasswordConf(e.target.value)} />
                        <p className='tinyText '>please use a strong password, at least 8 characters long, should contain at least 1 number and 1 special character</p>
                        <button disabled={!registerPasswordsOK} type="submit">Sign up</button>
                    </form>
                </div>


                <div className='bubbleContainer'>
                <p className='textCentered'>already registered? login below</p>
                    <form onSubmit={handleLogin}>
                        <h1>Sign in</h1>
                        <input type="email" placeholder="Email" value={emailLogin} onChange={(e) => setEmailLogin(e.target.value.toLowerCase())} />
                        <input type="password" placeholder="Password" value={passwordLogin} onChange={(e) => setPasswordLogin(e.target.value)} />
                        <button disabled={!loginDetailsOk} className='saveButton' >Sign in</button>
                        {/* <p className='tinyText' onClick={() => { navigate('reset-password') }}>restore password</p> */}
                    </form>
                </div>

            </article>
        </section>
    )
}

export default Signin;